/**
 * @@author        j0Shi
 * @@date          2019.07.04
 * @@desc          Functions related to proce data that's needed on different pages
 * @@usedby        Object
                   Booking
 */
export default {
  methods: {
    prhMixin_getVacancyData(hasObjectVacancy, objectVacancyData/* , objectSeasonData */) {
      if (!hasObjectVacancy) {
        return {
          count: 0,
          days: {},
          maxDate: new Date(),
        };
      }
      const { count, days, maxDate } = objectVacancyData;
      return {
        count, days, maxDate,
      };
    },
  },
};
